// extracted by mini-css-extract-plugin
export default {"cont":"VictimsDatabaseView_cont__+m110","link":"VictimsDatabaseView_link__5mCU2"};